import { View, Text } from "@react-pdf/renderer";
import {
  calculateAgeYear,
  formatHealth,
  formatToYYYY_MMM_DD,
  formatPhoneDocumentation,
} from "../../../../../helpers/functions";
import { COLORS, styles } from "../../../../forms/pdf-components/PdfStyles";
import { PdfH2 } from "../../../../forms/pdf-components/PdfText";
import {
  PdfRow,
  PdfCol,
  PdfVerticalDivider,
} from "../../../../forms/pdf-components/PdfLayout";
import { PdfDataField } from "../../../../forms/pdf-components/PdfDataField";

/**
 * PdfPatientAndContactInfo
 * Two-column layout:
 *   Left  — Patient Name, Health Card, DOB, Age
 *   Right — Primary Phone, Secondary Phone, Email
 *
 * Props:
 *   patient — patient object from Redux
 */
export const PdfPatientAndContactInfo = ({ patient = {} }) => {
  const patientName = [
    patient.firstName,
    patient.middleName,
    patient.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  const healthCard = patient?.provincialInsurance?.cardNumber
    ? `${formatHealth(patient.provincialInsurance.cardNumber)}-${
        patient.provincialInsurance.versionCode || ""
      }`
    : "XXX-XXX-XXX-EF";

  const dob = patient.dateOfBirth
    ? formatToYYYY_MMM_DD(patient.dateOfBirth)
    : "";
  const age = patient.dateOfBirth ? calculateAgeYear(patient.dateOfBirth) : "";

  const primaryPhone = (patient?.contactInfo?.primaryPhone || patient?.primaryPhone)
    ? formatPhoneDocumentation(patient?.contactInfo?.primaryPhone || patient?.primaryPhone)
    : "";
  const secondaryPhone = (patient?.contactInfo?.secondaryPhone || patient?.secondaryPhone)
    ? formatPhoneDocumentation(patient?.contactInfo?.secondaryPhone || patient?.secondaryPhone)
    : "";
  const email = patient?.contactInfo?.email || patient?.email || "";

  return (
    <View
      style={{
        borderWidth: 1,
        borderColor: COLORS.border,
        backgroundColor: COLORS.bgSection,
      }}
    >
      <PdfRow>
        {/* Left — Patient Information */}
        <PdfCol style={{ padding: 6 }}>
          <PdfH2 style={{ marginBottom: 3 }}>Patient Information</PdfH2>
          <PdfDataField label="Patient Name:" value={patientName} />
          <PdfDataField label="Health Card Number:" value={healthCard} />
          <PdfRow>
            <PdfCol>
              <PdfDataField label="Date of Birth:" value={dob} />
            </PdfCol>
            <PdfCol>
              <PdfDataField label="Age:" value={age} />
            </PdfCol>
          </PdfRow>
        </PdfCol>

        <PdfVerticalDivider style={{ marginVertical: 6 }} />

        {/* Right — Patient Contact Information */}
        <PdfCol style={{ padding: 6 }}>
          <PdfH2 style={{ marginBottom: 3 }}>Patient Contact Information</PdfH2>
          <PdfDataField label="Primary Phone Number:" value={primaryPhone} />
          <PdfDataField label="Secondary Phone:" value={secondaryPhone} />
          <PdfDataField label="Email Address:" value={email} />
        </PdfCol>
      </PdfRow>
    </View>
  );
};
